

export const presentSelector = state => state.present;
export const featureSelector = (state, feature) => presentSelector(state)[feature];